import React from "react";
import { AlertTriangle, Loader2 } from "lucide-react";

import UpgradePrompt from "../../components/plans/UpgradePrompt";
import { isPlanRequired } from "../../constants/plans";

/** Loading / error / empty body shared by every report page. */
const ReportStatus = ({ query, emptyTitle, emptyText }) => {
  if (query.isLoading) {
    return (
      <div className="flex flex-1 items-center justify-center py-24">
        <Loader2 className="animate-spin text-navy-900" size={32} aria-label="Cargando reporte" />
      </div>
    );
  }
  if (query.isError && isPlanRequired(query.error)) {
    // Reports outside the viewer's plan (DEV-43): retrying cannot help.
    return (
      <div className="mx-auto w-full max-w-2xl px-4 py-16">
        <UpgradePrompt error={query.error} />
      </div>
    );
  }
  if (query.isError) {
    return (
      <div className="flex flex-1 flex-col items-center justify-center gap-3 px-6 py-20 text-center">
        <AlertTriangle className="text-alert-300" size={36} aria-hidden="true" />
        <p className="font-medium text-navy-900">No se pudo generar el reporte.</p>
        <p className="max-w-md text-sm text-ink">{query.error?.message}</p>
        <button
          type="button"
          onClick={() => query.refetch()}
          className="rounded-lg bg-navy-900 px-4 py-2 text-sm font-semibold text-white hover:bg-navy-700"
        >
          Reintentar
        </button>
      </div>
    );
  }
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-2 px-6 py-20 text-center">
      <p className="font-display text-2xl font-semibold text-navy-900">{emptyTitle}</p>
      <p className="max-w-md text-sm text-ink">{emptyText}</p>
    </div>
  );
};

export default ReportStatus;
